module.exports = __webpack_public_path__ + "static/banner_c.59305915.png";